import React, { createContext, useContext, useState } from 'react';
import { CalendarClock, X, Bell } from 'lucide-react';
import { createPortal } from 'react-dom';
import { useT } from './LanguageContext';
import { useContent } from './ContentContext';

export const DEFAULT_SIGNUP = { mode: 'popup', url: '', title: 'Påmeldinga har ikkje starta enno', text: 'Vi opnar påmeldinga nærare helga. Meld deg på nyheitsbrevet, så får du beskjed først!', button: 'Få beskjed', buttonUrl: '/#nyheitsbrev' };

const SignupContext = createContext({ openSignup: () => {} });

export const SignupProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const { t } = useT();
  const { content } = useContent();
  const cfg = { ...DEFAULT_SIGNUP, ...(content.signup || {}) };
  const openSignup = () => {
    if (cfg.mode === 'link' && cfg.url) window.open(cfg.url, '_blank', 'noopener');
    else setOpen(true);
  };
  return (
    <SignupContext.Provider value={{ openSignup, signupConfig: cfg }}>
      {children}
      {open && createPortal(
        <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" data-testid="signup-dialog" role="dialog" aria-modal="true">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="relative w-full max-w-md rounded-3xl bg-[#0f0a17] border border-white/10 p-8 text-center shadow-2xl animate-[fadeUp_0.25s_ease-out]">
            <button type="button" onClick={() => setOpen(false)} aria-label="Lukk" data-testid="signup-dialog-close" className="absolute top-4 right-4 w-10 h-10 rounded-full border border-white/15 text-white flex items-center justify-center hover:border-[#ff2e2e] hover:text-[#ff2e2e]"><X size={18} /></button>
            <div className="mx-auto w-16 h-16 rounded-2xl bg-[#ff2e2e]/15 text-[#ff2e2e] flex items-center justify-center mb-5"><CalendarClock size={32} /></div>
            <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight mb-3" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{t(cfg.title)}</h3>
            <p className="text-white/60 mb-6">{t(cfg.text)}</p>
            <a href={cfg.buttonUrl || '/#nyheitsbrev'} target={/^https?:/.test(cfg.buttonUrl || '') ? '_blank' : undefined} rel="noreferrer noopener" onClick={() => setOpen(false)} data-testid="signup-dialog-newsletter-link" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#ff2e2e] text-black font-bold uppercase tracking-wide hover:bg-[#ff4d4d] transition-colors">
              <Bell size={16} /> {t(cfg.button)}
            </a>
          </div>
        </div>,
        document.body
      )}
    </SignupContext.Provider>
  );
};

export const useSignup = () => useContext(SignupContext);
